// The "top" colors of the themes – needs to correspond with the top theme colors in theming.scss
const primaryThemeColors: number[][] = [
    [41, 60, 145],
    [113, 191, 68],
    [24, 171, 157],
    [238, 64, 152],
    [239, 72, 40],
    [247, 150, 42],
    [125, 105, 174],
    [178, 210, 52],
    [246, 213, 69]
];

export default primaryThemeColors;
